export default "__VITE_ASSET__CSBVeLbE__"